import { render, staticRenderFns } from "./quota-list.vue?vue&type=template&id=1927cb10&scoped=true"
import script from "./quota-list.vue?vue&type=script&lang=js"
export * from "./quota-list.vue?vue&type=script&lang=js"
import style0 from "./quota-list.vue?vue&type=style&index=0&id=1927cb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1927cb10",
  null
  
)

export default component.exports